// extracted by mini-css-extract-plugin
export default {"screen-reader-features":"screen-reader-features--ZPz5t","screenReaderFeatures":"screen-reader-features--ZPz5t"};